import { useAppSelector } from "app/hooks";

const UserFullName = ({
  id,
  showCredentials,
}: {
  id: number | null | undefined;
  showCredentials?: boolean;
}) => {
  const user = useAppSelector((state) => state.users[id || 0]);

  if (!id || !user) return null;

  const { first_name, last_name, userprofile } = user;

  return (
    <UserFullNameDisplay
      first_name={first_name}
      last_name={last_name}
      credentials={userprofile?.credentials}
      showCredentials={showCredentials}
    />
  );
};

export const UserFullNameDisplay = ({
  first_name,
  last_name,
  credentials,
  showCredentials,
}: {
  first_name?: string;
  last_name?: string;
  credentials?: string | null;
  showCredentials?: boolean;
}) => {
  return (
    <>
      {[first_name, last_name].filter((s) => !!s).join(" ")}
      {showCredentials && credentials && <>, {credentials}</>}
    </>
  );
};

export default UserFullName;
